import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LabelRow = styled.div`
  display: flex;
  gap: 2px;
`;

export const FileInput = styled.input`
  padding: 8px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
  border: 1px dashed ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
  cursor: pointer;
`;
